import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { useHistory, useParams } from "react-router-dom";
import Loading from "../../components/Common/Loading";

function EditDownload(props) {
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const history = useHistory();
  const { id } = useParams();
  const user = useSelector((state) => state.User);
  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // Todo: get settings
  const getCategories = () => {
    setIsLoading(true);
    apiReq(url.GET_DOWNLOADS_CATEGORY, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setCategories(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  // Todo: get download item details
  const getDownloadItem = () => {
    setIsLoading(true);
    apiReq(url.DETAILS_DOWNLOADS_ITEMS + id, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("category", res.data.category._id);
          setValue("description", res.data.description);
          setFile(res.data.file);
          setImage(res.data.image);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCategories();
    getDownloadItem();
  }, [id]);

  //   console.log("category", params);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "downloads",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };
  // HandleAttachmentUpload
  const HandleAttachmentUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setFile(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (image === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Image",
      });
      return;
    } else if (file === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Attachment",
      });
      return;
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_DOWNLOADS_ITEMS + id,
        {
          title: data.title,
          description: data.description,
          category: data.category,
          image: image,
          file: file,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            history.push("/downloads/list");
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Edit Download</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label>Image</label>
                      <div
                        className="dropzone p-4 mb-3"
                        style={{ minHeight: 120 }}
                      >
                        {!image ? (
                          <div
                            className="needsclick"
                            // {...getRootProps()}
                          >
                            {/* <input /> */}
                            <div className="mb-3">
                              <i className="ri-image-line display-4 text-muted"></i>
                            </div>
                            <h5 className="opacity-40">Featured Image</h5>
                            <small className="text-muted mb-0 text-center">
                              <strong>(400X307)</strong>
                            </small>
                            <input
                              type="file"
                              className="image_upload_input"
                              onChange={(e) => handleLogoUpload(e)}
                            />
                          </div>
                        ) : (
                          <div className="filled_image">
                            <img
                              src={image}
                              alt="image"
                              className="img-fluid"
                            />
                            <div
                              className="remove_image"
                              onClick={() => setImage(null)}
                            >
                              <i className="mdi mdi-close-thick"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("title", { required: true })}
                      />
                      {errors.title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label>Category</label>
                    <select
                      className="form-control"
                      {...register("category", { required: true })}
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category._id}>
                          {category.title}
                        </option>
                      ))}
                    </select>
                    {errors.category && (
                      <span className="text-danger">Category is required</span>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <label>Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter description"
                    {...register("description", { required: true })}
                  />
                  {errors.description && (
                    <span className="text-danger">Description is required</span>
                  )}
                </div>
                <div className="mb-3 row">
                  <div className="col-md-2">
                    <label>Attachment</label>
                  </div>
                  <div className="col-md-6">
                    <strong>{file}</strong>
                  </div>
                  <div className="col-md-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <span style={{ marginRight: 10 }}>Change:</span>
                      <input
                        className="form-control"
                        type="file"
                        onChange={HandleAttachmentUpload}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default EditDownload;
